import { ManagerController } from "./organization.js";
import { EWA } from "./org.js";
export * from "./organization.js";
export * from "./misc.js";
export * from "./terms.js";
export { EWA };
export { registerEmployees } from "./register.js";
export const manager = function (client, baseUrl) {
    return new ManagerController(client, baseUrl);
};
